exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".portSec {\n  background-color: #6376A0;\n}\n\n.portSec h2{\n  color: white;\n}\n\n.portSec span h2{\n  color: #ECB807;\n}\n", ""]);

// exports
